import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  isFeedbackModalVisible: false,
  isPreferenceModalVisible: false,
  page: "",
  params: {},
};

export const standaloneSlice = createSlice({
  name: "standalone",
  initialState,
  reducers: {
    setIsFeedbackModalVisible: (state, action) => {
      state.isFeedbackModalVisible = action.payload;
    },
    setIsPreferenceModalVisible: (state, action) => {
      state.isPreferenceModalVisible = action.payload;
    },
    setStandalonePage: (state, action) => {
      state.page = action.payload;
    },
    setStandaloneParams: (state, action) => {
      state.params = action.payload;
    },
  },
});

export const getIsFeedbackModalVisible = (state) => state.standalone.isFeedbackModalVisible;
export const getIsPreferenceModalVisible = (state) => state.standalone.isPreferenceModalVisible;
export const getStandalonePage = (state) => state.standalone.page;
export const getStandaloneParams = (state) => state.standalone.params;
export const { setIsFeedbackModalVisible, setIsPreferenceModalVisible, setStandalonePage, setStandaloneParams } = standaloneSlice.actions;

export default standaloneSlice.reducer;
